import React from 'react'
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom'
import { Login, Toast } from '@leverege/ui-elements'
import { Auth } from '@leverege/api-redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import LoginScreen from '~/screens/login/LoginScreen'
import MainScreen from '~/screens/main/MainScreen'

class App extends React.Component {

  static childContextTypes = {
    api : PropTypes.object
  };

  static contextTypes = {
    store : PropTypes.object
  }

  static propTypes = {
    api : PropTypes.object.isRequired,
    location : PropTypes.object
  }

  getChildContext() {
    const { api } = this.props
    return { api }
  }

  render() {
    const { auth, api, history } = this.props

    // const ifAuthorized = ( component, props ) => {
    //   if ( auth.isLoggedIn( ) ) {
    //     const t = { component }
    //     return <t.component auth={auth} {...props} />
    //   }

    //   if ( props.location?.pathname !== '/login' ) {
    //     auth.setReturnToPath( props.location.pathname )
    //   }
    //   return <Redirect to={{ pathname : '/login', state : { from : props.location } }} />
    // }

    let routes

    if ( Auth.isLoggedIn( auth ) ) {
      routes = [
        <Route key="home" path="/" exact={false} render={props => ( <MainScreen {...props} /> )} />
      ]
    } else {
      routes = [
        <Route key="login" render={props => ( <LoginScreen {...props} auth={auth} /> )} />
      ]
    }

    return ( 
      <div style={{ height : '100%' }}>
        <Switch>
          {routes}
        </Switch>
        <Toast style={{ zIndex : 100000 }} />
      </div>
    )
  }

  renderLogin() {
    const { auth } = this.props 
    return <LoginScreen auth={auth} />
  }
}

export default connect( ( state ) => {
  return {
    auth : state.auth
  }
} )( App )
